import angular from 'angular'

angular.module('admin.genres.service', []).factory('GenresService', GenresService)

/** @ngInject */
function GenresService($http, $q, API) {
  function list(start, limit) {
    var defered = $q.defer()

    $http
      .get(API.API_URL + 'admin/genres?start=' + start + '&limit=' + limit + '&sort=n-asc')
      .success(defered.resolve)

    return defered.promise
  }

  function listGenreOrders(genreId) {
    var defered = $q.defer()

    $http.get(API.API_URL + 'admin/genres/' + genreId + '/orders').success(defered.resolve)

    return defered.promise
  }

  function listPublish(start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL + 'admin/genres/published?start=' + start + '&limit=' + limit + '&sort=n-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function listArchived(start, limit) {
    var defered = $q.defer()

    $http
      .get(API.API_URL + 'admin/genres/expired?start=' + start + '&limit=' + limit + '&sort=n-asc')
      .success(defered.resolve)

    return defered.promise
  }

  function listUnpublish(start, limit) {
    var defered = $q.defer()

    $http
      .get(
        API.API_URL + 'admin/genres/unpublished?start=' + start + '&limit=' + limit + '&sort=n-asc',
      )
      .success(defered.resolve)

    return defered.promise
  }

  function listChannelsByGenre(genreId, start, limit) {
    var defered = $q.defer()

    $http
      .get(API.API_URL + 'genres/' + genreId + '/channels?start=' + start + '&limit=' + limit)
      .success(defered.resolve)

    return defered.promise
  }

  function get(id) {
    var defered = $q.defer()

    $http.get(API.API_URL + 'admin/genres/' + id).success(defered.resolve)

    return defered.promise
  }

  function save(model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'admin/genres', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function update(id, model) {
    var defered = $q.defer()

    $http
      .put(API.API_URL + 'admin/genres/' + id, model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function remove(id) {
    var defered = $q.defer()

    $http
      .delete(API.API_URL + 'admin/genres/' + id)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function setOrder(genreId, model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'admin/genres/' + genreId + '/set_order', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  function unsetOrder(genreId, model) {
    var defered = $q.defer()

    $http
      .post(API.API_URL + 'admin/genres/' + genreId + '/unset_order', model)
      .success(defered.resolve)
      .error(defered.reject)

    return defered.promise
  }

  return {
    list: list,
    listChannelsByGenre,
    get: get,
    save: save,
    update: update,
    remove: remove,
    listPublish,
    listArchived,
    listUnpublish,
    listGenreOrders,
    setOrder,
    unsetOrder,
  }
}
